import axios from "axios";
import { post } from "@/services/axiosService"
import { IFetchProfileRequest, IFetchProfileResponse } from "@/common/apiDataModel";

export const fetchProfile: (model: IFetchProfileRequest) => Promise<IFetchProfileResponse>  = async(model) => {
  return await post<IFetchProfileRequest,IFetchProfileResponse>(model, "fetchProfile");
}